<template>
  <div class="container--fluid">
    <div class="row align-center">
      <v-col cols="6" class="image-prod">
        <img :src="imageProds[currentIndex]" />
      </v-col>
      <div class="col pl-12 container-prod">
        <h5 class="title-prod" style="margin: auto">
          {{ product.name }}
        </h5>
        <div class="ml-4">
          <span class="price-new mr-2">{{ product.priceOld }}</span>
          <span class="price-old">{{ product.priceNew }}</span>
        </div>
        <div class="ml-6">
          <div
            v-for="(discount, idx) in product.discount"
            :key="idx"
            class="row no-gutters justify-start"
          >
            <v-col cols="auto">
              <v-icon small left color="green">{{ mdiCheck }}</v-icon>
            </v-col>
            <v-col>
              <small class="discount">{{ discount }}</small>
            </v-col>
          </div>
        </div>
        <div>
          <a :href="product.url" target="_blank" style="text-decoration: unset">
            <v-btn dark class="button-buy">Mua hàng</v-btn>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiCheck } from "@mdi/js";

export default {
  name: "Product",
  props: {
    product: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      model: null,
      mdiCheck: mdiCheck,
      timer: null,
      currentIndex: 0,
    };
  },
  computed: {
    imageProds() {
      return [this.product.image, ...(this.product.sub_images || [])];
    },
  },
  methods: {
    setAutoRoll() {
      let vueSelf = this;
      this.timer = setInterval(function () {
        vueSelf.addIndex();
      }, 1500);
    },
    addIndex() {
      let newIndex = this.currentIndex + 1;
      this.currentIndex = newIndex === this.imageProds.length ? 0 : newIndex;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.setAutoRoll();
  },
};
</script>

<style scoped></style>
